<div class="flex--row flex--gutter panel-container">
  <ng-container
    *ngIf="
      !(
        (normalizedTimeSeriesArray$ | async) === undefined ||
        (normalizedTimeSeriesArray$ | async).length === 0
      ) && (benchmarkSettings$ | async);
      let benchmarkSettings
    "
  >
    <ng-container
      *ngIf="
        benchmarkSettings.selectedNonDetailedBenchmarkType === 'selectedPeriod' &&
        (benchmarkSelectedPeriodData$ | async)?.flocksUsed >= 0
      "
    >
      <agr-summary-card-horizontal
        *ngIf="benchmarkSelectedPeriodData$ | async; let benchmarkSelectedPeriodData"
        [title]="
          getBenchmarkTitle(
            benchmarkSelectedPeriodData,
            selectedDataViewType$ | async,
            benchmarkSettings
          )
        "
        class="panel flex__child--col-2 col-2 spacing--margin-bottom avoid-page-break"
        data-test="benchmarks"
        [items]="
          getBenchmarks(normalizedTimeSeriesArray$ | async, benchmarkSelectedPeriodData, true)
        "
      >
      </agr-summary-card-horizontal>
    </ng-container>
    <ng-container
      *ngIf="
        benchmarkSettings.selectedNonDetailedBenchmarkType === 'lastWeeks' &&
        (benchmarkLastWeeksData$ | async)?.flocksUsed >= 0
      "
    >
      <agr-summary-card-horizontal
        *ngIf="benchmarkLastWeeksData$ | async; let benchmarkLastWeeksData"
        [title]="
          getBenchmarkTitle(
            benchmarkLastWeeksData,
            selectedDataViewType$ | async,
            benchmarkSettings
          )
        "
        class="panel flex__child--col-2 col-2 spacing--margin-bottom avoid-page-break"
        data-test="benchmarks"
        [items]="getBenchmarks(normalizedTimeSeriesArray$ | async, benchmarkLastWeeksData, true)"
      >
      </agr-summary-card-horizontal>
    </ng-container>
    <ng-container
      *ngIf="benchmarkSettings.selectedNonDetailedBenchmarkType === 'customerAverageSelectedPeriod'"
    >
      <agr-summary-card-horizontal
        *ngIf="
          benchmarkCustomerAveragSelectedPeriodData$ | async;
          let benchmarkCustomerAveragSelectedPeriodData
        "
        [title]="
          getBenchmarkTitle(
            benchmarkCustomerAveragSelectedPeriodData,
            selectedDataViewType$ | async,
            benchmarkSettings
          )
        "
        class="panel flex__child--col-2 col-2 spacing--margin-bottom avoid-page-break"
        data-test="benchmarks"
        [items]="
          getBenchmarks(
            normalizedTimeSeriesArray$ | async,
            benchmarkCustomerAveragSelectedPeriodData,
            false
          )
        "
      >
      </agr-summary-card-horizontal>
    </ng-container>
  </ng-container>

  <agr-summary-card-horizontal
    *ngFor="let ts of normalizedTimeSeriesArray$ | async"
    [title]="getTitle(ts, selectedDataViewType$ | async)"
    class="panel flex__child--col-2 col-2 spacing--margin-bottom avoid-page-break"
    [attr.data-test]="'data-table-panel__' + ts.locationName"
    [items]="getSummaryCardItems(ts)"
  >
  </agr-summary-card-horizontal>

  <agr-notification-empty
    [isEmpty]="
      (normalizedTimeSeriesArray$ | async) === undefined ||
      (normalizedTimeSeriesArray$ | async).length === 0
    "
  >
  </agr-notification-empty>
</div>
